import { useEffect, useState } from 'react';

import { ordersGateway } from '../gateways/OrdersApi/OrdersApi';
import {
  GeneratedCalculateOrderPricingInputItem,
  GeneratedOrdersPriceCalculation,
} from '../types/generated';
import { CurrencyCode } from '../types/Locations';
import { captureError } from '../utils/capture';
import { useCountryCode } from './useCountryCode';
import { useCurrency } from './useCurrency';

export type CalculateOrderPricingProps = {
  items: GeneratedCalculateOrderPricingInputItem[];
  forceCurrency?: CurrencyCode;
};

export type CalculatedOrderPricing = {
  calculation?: GeneratedOrdersPriceCalculation;
  loading: boolean;
};

export const useCalculateOrderPricing = ({
  forceCurrency,
  items,
}: CalculateOrderPricingProps): CalculatedOrderPricing => {
  const [country] = useCountryCode();
  const [currency] = useCurrency();

  const [calculation, setCalculation] = useState<
    GeneratedOrdersPriceCalculation | undefined
  >(undefined);
  const [loading, setLoading] = useState(false);

  const currencyCode = forceCurrency || currency;

  useEffect(() => {
    if (items.length === 0) return;

    setLoading(true);
    ordersGateway
      .calculateOrderPricing({
        countryCode: country,
        currencyCode,
        items,
      })
      .then((calculatedSumToPay) => {
        setCalculation(calculatedSumToPay);
      })
      .catch((err) => {
        captureError(err as Error);
      })
      .finally(() => setLoading(false));
  }, [items, country, currencyCode]);

  return {
    calculation,
    loading,
  };
};
